import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {useDeleteSession} from "../../../../features/sessions";

export function useDeleteBundleHook(bundleId: number) {
  const deleteSessionMutation = useDeleteSession();
  const navigate = useNavigate();

  function deleteBundle(): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const onSuccess = () => {
        message.success("The selected bundle has been deleted successfully!");
        navigate("/calls");
      };

      resolve(
        deleteSessionMutation.mutateAsync(bundleId, {
          onSuccess,
        })
      );
    }).catch(() => {});
  }

  return {
    deleteBundle,
  };
}
